module.exports = __webpack_public_path__ + "img/kaiju-2.fa2d9f4b.png";